import { ProductOptionsWithHex } from "constants/dataDresdenTypes";
import { useRouter } from "next/router";


const checkFrameArmsVariation = (frameShape: string, frameArmsOptions: ProductOptionsWithHex, type: string, size: string, color: string) => {
  if (!frameArmsOptions) return false;

  if (type === 'both') {
    return checkFrame(frameShape, frameArmsOptions, size, color) && checkArms(frameArmsOptions, size, color);
  } else if (type === 'Frame') {
    return checkFrame(frameShape, frameArmsOptions, size, color);
  } else {
    return checkArms(frameArmsOptions, size, color);
  }
};

const checkFrame = (frameShape: string, frameArmsOptions: ProductOptionsWithHex, size: string, color: string) => {

  const frameOption = frameArmsOptions.frame_options.find(option => option.shape.toLowerCase() === frameShape.toLowerCase());
  if (!frameOption) return false;

  const colorOption = frameOption.color_size.find(cs => cs.slug === color);
  return colorOption ? colorOption.size_list.includes(size) : false;
};

const checkArms = (frameArmsOptions: ProductOptionsWithHex, size: string, color: string) => {
  const armsOption = frameArmsOptions.arms_options.find(option => option.slug === color);
  return armsOption ? armsOption.size_list.includes(size) : false;
};

export default checkFrameArmsVariation;